import { decodeHexResponse } from '../_common/common.utils';
import GetValueDashboardForIndividualTypes from './GetValueDashboardForIndividual.types';

const INITIAL_STATE = {
	getValueDashboardForIndividualResponse: null,
};

const getValueDashboardForIndividualReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case GetValueDashboardForIndividualTypes.GET_VALUE_DASHBOARD_FOR_INDIVIDUAL_START:
			return { ...state, getValueDashboardForIndividualResponse: null };
		case GetValueDashboardForIndividualTypes.GET_VALUE_DASHBOARD_FOR_INDIVIDUAL_SUCCESS:
			return {
				...state,
				getValueDashboardForIndividualResponse: decodeHexResponse(
					action.payload,
					'fetchValueDashboardForIndividualDataKey',
				),
			};
		case GetValueDashboardForIndividualTypes.GET_VALUE_DASHBOARD_FOR_INDIVIDUAL_FAILURE:
			return {
				...state,
				getValueDashboardForIndividualResponse: decodeHexResponse(
					action.payload,
					'fetchValueDashboardForIndividualDataKey',
				),
			};
		case GetValueDashboardForIndividualTypes.GET_VALUE_DASHBOARD_FOR_INDIVIDUAL_RESPONSE_CHANGED:
			return { ...state, getValueDashboardForIndividualResponse: null };
		case GetValueDashboardForIndividualTypes.GET_VALUE_DASHBOARD_FOR_INDIVIDUAL_RESPONSE_REST_START:
			return { ...state, getValueDashboardForIndividualResponse: null };
		default:
			return state;
	}
};

export default getValueDashboardForIndividualReducer;
